import { OfferingLocationType, } from './offering-location.dto';
var OfferingLocationDtoBuilder = /** @class */ (function () {
    function OfferingLocationDtoBuilder() {
        this.location = {
            type: OfferingLocationType.BUSINESS,
            locationText: 'location text',
        };
    }
    OfferingLocationDtoBuilder.prototype.withType = function (type) {
        this.location.type = type;
        return this;
    };
    OfferingLocationDtoBuilder.prototype.withLocationText = function (locationText) {
        this.location.locationText = locationText;
        return this;
    };
    OfferingLocationDtoBuilder.prototype.build = function () {
        return this.location;
    };
    return OfferingLocationDtoBuilder;
}());
export { OfferingLocationDtoBuilder };
//# sourceMappingURL=offering-location.dto.builder.js.map